import { createFileRoute } from "@tanstack/react-router";
import { SmartApiComparePage } from "../../components/system/SmartApiComparePage";
import { requireSuperAdmin } from "../../lib/auth/route-protection";

export const Route = createFileRoute("/system/smart-api")({
  beforeLoad: requireSuperAdmin(),
  component: SmartApiCompareRoute,
});

function SmartApiCompareRoute() {
  return <SmartApiComparePage />;
}
